import React from "react";
import { GatewaysListsView } from "@src/components/organisms/gateways-list-view/gateways-list-view";
import { NoGatewaysDetectedView } from "@src/components/organisms/no-gateways-detected-view/no-gateways-detected-view";
import Spinner from "@src/components/atoms/spinner/spinner";
import { SubHeader } from "@src/components/atoms/sub-header/sub-header";
import { SubTitle } from "@src/components/atoms/sub-title/sub-title";
import { ButtonWithIcon } from "@src/components/atoms/buttons/button-with-icon/button-with-icon";
import plusIcon from "@src/assets/svg/plus-icon.svg";
import { useDispatch } from "react-redux";
import { updateModalsCloseDrawerModal } from "@src/reducers/your-reducer";
import { useI18N } from "@src/language/language-context";
import { RenderIfUserHasMultiplePermissions } from "@src/components/molecules/render-if-user-has-multiple-permissions/render-if-user-has-multiple-permissions";
import { ContainerPanel } from "@src/components/organisms/container-panel/container-panel";
import { ContainerPane } from "@src/components/organisms/container-pane/container-pane";

export interface GatewaysComponentProps {
  viewToBeRendered?: string;
}

export const GatewaysListComponent = ({
  viewToBeRendered,
}: GatewaysComponentProps) => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const texts = {
    subtitle: i18n("modules.gatewaysListView.subtitle"),
    addGatewayButton: i18n("modules.gatewaysListView.addGatewayButton"),
  };

  const addNewGatewayManuallyClickHandler = (
    e: React.MouseEvent<Element> | React.KeyboardEvent<Element>,
  ) => {
    e.preventDefault();
    dispatch(
      updateModalsCloseDrawerModal({
        showModal: true,
        id: "addNewGatewayDrawerModal",
      }),
    );
  };

  const renderGatewaysView = () => {
    switch (viewToBeRendered) {
      case "GatewaysListsView":
        return <GatewaysListsView />;
      case "NoGatewaysDetectedView":
        return <NoGatewaysDetectedView />;
      case "SpinningForData":
        return <Spinner />;
      default:
        return <NoGatewaysDetectedView />;
    }
  };
  return (
    <ContainerPanel>
      <SubHeader>
        <SubTitle text={texts.subtitle} />
        <>
          <RenderIfUserHasMultiplePermissions
            permissions={["manage-gateways", "manage-sources"]}
            requireAll
          >
            <RenderIfUserHasMultiplePermissions
              permissions={["view-licenses", "manage-licenses"]}
            >
              <ButtonWithIcon
                icon={plusIcon}
                fun={(e) => addNewGatewayManuallyClickHandler(e)}
                text={texts.addGatewayButton}
                variant={["no-outline-with-green20-hover", "color-blue"]}
              />
            </RenderIfUserHasMultiplePermissions>
          </RenderIfUserHasMultiplePermissions>
        </>
      </SubHeader>
      <ContainerPane>{renderGatewaysView()}</ContainerPane>
    </ContainerPanel>
  );
};
